import { FC } from 'react';

import { AppFormattedMessage } from '../../../../components/app-formatted-message/index';
import { useFormat } from '../../../../hooks/index';
import { eventFormType, EventTypeBackend } from '../../../../types/events.types';
import { toMathRound } from '../../../../utils/to-math-round.util';
import { CardProps } from './transaction-card-variants.types';
import { TransactionOverviewItem } from './transaction-overview-item';
import { TransactionTitleItem } from './transaction-title-item';

export const Valuation: FC<CardProps> = ({ event }) => {
  const { format } = useFormat();
  if (event.type !== EventTypeBackend.VALUATION) return <></>;
  const { type, date, name, sharePrice, issuedSharesOnStart } = event;

  const roundedSharePrice = toMathRound(sharePrice);

  return (
    <div className="flex flex-col divide-y divide-gray-100 rounded-md shadow-sm">
      <TransactionTitleItem createdAt={format(date, 'dd/MM/yyyy')} name={name} />
      <TransactionOverviewItem
        title={<AppFormattedMessage id="TRANSACTION_TYPE" />}
        value={<AppFormattedMessage id={eventFormType[type]} />}
      />
      <TransactionOverviewItem
        title={<AppFormattedMessage id="SHARES_PRICE" />}
        value={roundedSharePrice.toLocaleString('en-US')}
      />
      <TransactionOverviewItem
        title={<AppFormattedMessage id="PRE_MONEY_VALUATION" />}
        value={(issuedSharesOnStart * sharePrice).toLocaleString('en-US')}
      />
    </div>
  );
};
